<template>
    <div style="background: #fff;">
        <van-nav-bar
                title="换码"
        />
      <van-cell center title="自动补充新码" style="text-align: left">
        <template #right-icon>
          <van-switch v-model="checked" size="24" />
        </template>
      </van-cell>
      <template v-if="checked">
        <p style="font-size: 12px;text-align: left;color: #9c0003;padding: 0 15px;">开启自动识别后，将按照顺序自动填充新码（需要先扫描两组号码,以识别是递增或递减）</p>
      </template>
        <div style="padding: 20px">
            <ul class="card-list">
                <li class="card-item">
                    <div style="text-align: left;min-width: 40px">序号</div>
                    <div style="width: 100%;display: flex;text-align: center">
                        <div style="width: 100%;"> 旧码</div>
                        <div style="width: 100%;">新码</div>
                    </div>
                    <div style="width: 20%;text-align: right">操作</div>
                </li>
              <li class="card-item"  v-for="(item,index) in iccid1">
                <div style="text-align: left;min-width: 40px">{{index+1}}</div>
                <div style="width: 100%;display: flex;">
                  <div style="width: 100%;"> {{item}}</div>
                  <div style="width: 100%;">{{short_number1[index]}}</div>
                </div>
                <div class="del" style="width: 20%;text-align: right;color: #1fe66a">成功</div>
              </li>
                <li class="card-item"  v-for="(item,index) in iccid">
                    <div style="text-align: left;min-width: 40px">{{index+1}}</div>
                    <div style="width: 100%;display: flex;">
                        <div style="width: 100%;"> {{item}}</div>
                        <div style="width: 100%;color: #3a8ee6;">{{short_number[index]}}</div>
                    </div>
                    <div class="del" style="width: 20%;text-align: right" @click="remove(index)">删除</div>
                </li>
            </ul>


            <van-row>
                <van-cell>
                    <div  v-if="wxReady==true">
                    <van-button type="primary" @click="handleScan" block icon="qr">扫码</van-button>
                    </div>
                    <p v-else style="font-size: 14px;color: #ff5257;line-height: 100px;text-align: center;">请等待扫码组件加载完成</p>
                </van-cell>
                <van-cell>
                    <van-button type="info" v-if="iccid.length > 0" @click="handleSubmit" block icon="upgrade">提交绑定
                    </van-button>
                </van-cell>
            </van-row>
        </div>
    </div>
</template>

<script>
    import wx from "weixin-js-sdk";
    function zerofile(number,length) {
      number = number+'';
      while (number.length<length){
        number = '0'+number
      }
      return number
    }
    export default {
        name: "productBind",
        data() {
            return {
                wxReady: false,
                checked:false,
                iccid: [],
                short_number: [],
                iccid1:[],
                short_number1:[],
              shortBase:'',
            };
        },
        methods: {
            initWechatJs() {
                let url = encodeURIComponent(location.href.split('#')[0])
                this.fetchData('/wechat/jssdk', {url: url}, (res) => {
                    if (res.code) {
                        wx.config(res.data);
                        wx.ready(() => {
                            this.wxReady = true;
                        })
                    }
                })
            },
            handleScantest(){
              let iccid = 'FB'+Math.floor(Math.random()*10000);

              if (this.iccid.length == this.short_number.length) {
                this.iccid.push(iccid)
                if (this.checked==true && this.short_number1.length>=2){
                  let shortItem;
                  //新码自动补全
                  this.shootType = this.short_number1[0].substr(-2) > this.short_number1[1].substr(-2) ? 1 : 0
                  if(this.short_number1[0].substr(-2) == '99' && this.short_number1[1].substr(-2) == '00'){
                    this.shootType = 0
                  }
                  if(this.short_number1[1].substr(-2) == '99' && this.short_number1[0].substr(-2) == '00'){
                    this.shootType = 1
                  }
                  let short1 = this.short_number1[this.short_number1.length - 1]
                  let letPosition = [];
                  for (let i in short1) {
                    if (/[a-zA-Z]/.test(short1[i])) {
                      letPosition[i] = short1[i]
                    }
                  }
                  let lastShort = short1.replace(/[a-zA-z]/g, '', short1);

                  if(!this.shortBase) {
                    short1 = parseInt(short1.replace(/[a-zA-z]/g, '', short1));
                  }else{
                    short1 = this.shortBase
                  }


                  let shortLength = lastShort.length
                  if (this.shootType == 1) {
                    shortItem = (short1 - 1);
                  } else {
                    shortItem = (short1 + 1);
                  }
                  this.shortBase = shortItem
                  shortItem = zerofile(shortItem,shortLength)
                  for (let index in letPosition) {
                    if (letPosition[index]) {
                      shortItem = shortItem.substr(0, index) + letPosition[index] + shortItem.substr(index)
                    }
                  }

                  this.short_number.push(shortItem)
                }



              } else {
                this.short_number.push(iccid)
              }

            },
            handleScan() {
                if (!this.wxReady) {
                    this.$toast.fail('扫码控件初始化失败')
                    return false;
                }
                wx.scanQRCode({
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    success: (res) => {
                        let result = res.resultStr;
                        let iccid=''
                        if (result.indexOf('http') != -1) {
                            //地址二维码
                            const regexp = /(iccid|no)\=([\da-zA-Z]{1,})/
                            if (regexp.test(result) == false) {
                                this.$toast.fail('无法识别的二维码')
                                return false;
                            }
                            iccid = result.match(regexp)[2]

                        } else {
                            return  this.$toast.fail("无法识别")
                        }
                        if (!iccid || iccid == undefined) {
                            this.$toast.fail('无法识别的二维码')
                            return false;
                        }
                        if (this.iccid.length == this.shoort_number1.length) {
                            this.iccid.push(iccid)
                        } else {
                            this.short_number.push(iccid)
                        }

                    }
                });
            },
            remove(index) {
                this.iccid.splice(index, 1)
                this.short_number.splice(index, 1)
            },
            handleSubmit() {
                if (this.iccid.length == 0) {
                    this.$toast.fail('请先扫码录入');
                    return false;
                }
                if (this.iccid.length != this.short_number.length) {
                    this.$toast.fail('旧码与新码数量不一致');
                    return false;
                }
                this.$toast.loading('提交中')
                this.fetchDataPost('/base/changenumber', {
                    iccid: this.iccid,
                    short_number: this.short_number
                }, res => {
                    this.$toast.clear();
                    if (res.code) {
                        this.$toast.success(res.msg)
                      for (let i in this.iccid){
                        this.iccid1.push(this.iccid[i])
                        this.short_number1.push(this.short_number[i])
                      }
                      this.iccid = []
                      this.short_number = []
                    } else {
                        this.$toast.fail(res.msg);
                    }

                })

            },

        },
        created: function () {
            this.initWechatJs()
        }
    };
</script>
<style lang="scss">
    .card-item{
        padding: 10px 0;
        display: flex;
        font-size: 15px;
        .del{
            color: #ff5257;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/changecode.vue